<template>
<div>

   <div class="select-path">
       <h1 style="text-align:center;color:white;margin-bottom:40px">
       בחר את המסלולים שלך
       </h1>
    <div class="path-box w-inline-block" :class="{'selected':paths.includes(item._id)}"  v-for="item in cbPaths" :key="item._id" @click="togglePath(item._id)">
        <h3>{{item.title}}</h3>
        <p class="path-description">{{item.description}}</p>
    </div>
    <div class="path-action">
    
    <a @click="submitPaths()" class="btn sign w-button">הרשמה</a>
    <loader v-if="this.loading" />
    </div>
     <br/>
    </div>

</div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import loader from "../components/loader";
export default {
  name: "signUp",
  components:{loader},
  data() {
    return {
      paths:[],
      loading: false,
      signInError: false,
    };
  },
  methods: {
    async submitPaths(){
      this.loading=true;
      console.log(this.paths);
      await this.registerPaths(this.paths)
      if(!this.getUser.userPaths){
        console.log('user doesn\'t approved');
       await  this.$router.push({name: "pathsNotRegistered"});
      }
      else {console.log('User approved!');
       await this.$router.push({name: "Paths"});}

      this.loading=false
    },
    togglePath(id){
      if (this.paths.includes(id)){
        this.paths = this.paths.filter(path=>path!=id)
      } else {
        this.paths.push(id)
      }
    },
    ...mapActions(["fetchCbPaths","registerPaths"]),
  },
  computed: {
    ...mapGetters(["getErrMsg", "getUser"]),
    cbPaths() {
      return this.$store.getters.getPaths;
    },
  },
  created() {
    this.fetchCbPaths();
  },
};
</script>

<style scoped>
  /* .path-box h3{
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  } */
</style>